<div class="team-member-row" [class.is-expanded]="expanded">
  <span class="team-member-row__name">
    <span class="team-member-row__name-text">{{ person?.displayName }}</span>
    <ciao-guest-badge
      *ngIf="person?.id"
      [person]="person"
      variant="table"
    ></ciao-guest-badge>
  </span>
  <span class="team-member-row__email">{{ email || "—" }}</span>
  <span
    class="team-member-row__phone"
    [class.team-member-row__phone--missing]="!phone"
  >{{ phone || "No phone on file" }}</span>
  <span class="team-member-row__action">
    <button
      type="button"
      class="team-member-row__chevron"
      (click)="toggleExpanded()"
      [attr.aria-expanded]="expanded"
      [attr.aria-label]="(expanded ? 'Collapse ' : 'Expand ') + (person?.displayName || 'member')"
    >
      <span aria-hidden="true">{{ expanded ? "▴" : "▾" }}</span>
    </button>
    <button
      *ngIf="canRemove"
      type="button"
      class="team-member-row__remove"
      (click)="onRemoveClick()"
      [attr.aria-label]="'Remove ' + (person?.displayName || 'member')"
    >
      Remove
    </button>
  </span>
  <!--
    Mobile-only accordion details. The container occupies a grid row that's
    only laid out at narrow viewports; on desktop these labels are hidden
    by the row's media query (email/phone show in their own columns above).
  -->
  <div class="team-member-row__details">
    <div class="team-member-row__detail-row">
      <span class="team-member-row__detail-label">Email</span>
      <span class="team-member-row__detail-value">{{ email || "—" }}</span>
    </div>
    <div class="team-member-row__detail-row">
      <span class="team-member-row__detail-label">Phone</span>
      <span
        class="team-member-row__detail-value"
        [class.team-member-row__detail-value--missing]="!phone"
      >{{ phone || "No phone on file" }}</span>
    </div>
  </div>
</div>
